import type {AllApiSchema} from '@repo/shared/api/core/api_schema';
import type {ApiConfig, ApiName} from '@repo/shared/api/core/api_types';
import {WEBSITE_API} from '@repo/shared/api/website_api';

export const ALL = {
  website_backend: WEBSITE_API,
} satisfies AllApiSchema;

export const WEBSITE_API_PATHS = Object.entries(WEBSITE_API).flatMap(([path, methods]) =>
  Object.keys(methods).map(method => `${method} ${path}`),
);

export const API_CONFIGS = {
  website_backend: {host: '/'},
} satisfies Record<ApiName, ApiConfig>;
